const parseOffset = (timeZoneName) => {
    const match = timeZoneName.match(/\((.*?)\)/);
    if (!match) {
        return 0;
    }
    const [, offset] = match;
    const [hours, minutes] = offset.split(':');
    const [sign] = offset;
    return parseInt(`${sign}${Math.abs(hours) * 3600 + minutes * 60}`);
};
const timeZoneMapper = (timeZone) => ({
    ianaId: timeZone.id,
    name: timeZone.text,
    offsetSeconds: parseOffset(timeZone.text),
    id: 0,
    description: '',
});
export const timeZonesAdapter = (timezones) => timezones.reduce((acc, timeZone) => {
    acc.timeZones.push(timeZoneMapper(timeZone));
    if (timeZone.isDefault) {
        acc.userTimeZone = timeZoneMapper(timeZone);
    }
    return acc;
}, {
    userTimeZone: {},
    timeZones: [],
});
